import { render, staticRenderFns } from "./newEnergy.vue?vue&type=template&id=c9f23d24&scoped=true"
import script from "./newEnergy.vue?vue&type=script&lang=js"
export * from "./newEnergy.vue?vue&type=script&lang=js"
import style0 from "./newEnergy.vue?vue&type=style&index=0&id=c9f23d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f23d24",
  null
  
)

export default component.exports